module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "part",
    attrs: {
      "epub:type": "part",
      "id": "part-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_c('div', {
    staticClass: "part_debut"
  }), _vm._v(" "), _c('section', {
    staticClass: "exergues",
    attrs: {
      "epub:type": "epigraph"
    }
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('i', [_vm._v("Look! For you, there are threats, punishments, tortures, and crosses. . . . Where is that God who is able to help you when you come to life again, if he cannot help you while you are in this life?")])]), _vm._v(" "), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGAN ANTAGONIST, IN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARCUS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INUCIUS")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELIX,"), _c('br')]), _c('i', [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("HE ")])]), _c('i', [_vm._v("O")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("CTAVIUS OF ")])]), _c('i', [_vm._v("M")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("INUCIUS ")])]), _c('i', [_vm._v("F")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("ELIX")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-045",
      "id": "ap_ntf-045-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('i', [_vm._v("It is evident that no one can terrify or subdue us. For, throughout all the world, we have believed in Jesus! It is clear that, although beheaded, and crucified, and thrown to wild beasts . . . and fire, and all other kinds of torture, we do not give up our confession. But the more such things happen, the more do other persons and in larger numbers become faithful believers and worshippers of God through the name of Jesus.")])]), _vm._v(" "), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USTIN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARTYR")]), _vm._v(", "), _c('i', [_vm._v("D")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("IALOGUE WITH ")])]), _c('i', [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("RYPHO")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-046",
      "id": "ap_ntf-046-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345225b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1.vue
// module id = 78
// module chunks = 0